import React, { FC, ReactElement } from 'react';

import styles from './styles.module.scss';

import { TooltipWrapper } from 'components/index';

import { DATA_NOT_FOUND } from 'constants/dataNotFound';

import { TableHeader } from '../TableHeader';
import { TableRow } from '../TableRow';

import { useAppSelector } from 'store';
import { FormatUtils } from 'utils';
import { TableProBlur } from 'components/OrganizationPageBody/components/OrganizationData/components/OrganizationTreasury/components/DaoAssetsTable/components/TableProBlur';
import { TRENDS_TAB, TRENDS_TAB_DESCRIPTIONS } from 'constants/descriptions';

type VotingActivityTableProps = {
    showBlur?: boolean;
};
export const VotingActivityTable: FC<VotingActivityTableProps> = ({ showBlur = false }): ReactElement => {
    const {
        organizationActivityData: {
            voteActivity: { avgVotesPerProposal, votersCount, votesCount },
        },
    } = useAppSelector(({ organization }) => organization);
    const votesNumber = votesCount && !showBlur ? votesCount : 2442;
    const totalVotesNumber = votersCount && !showBlur ? votersCount : 1000;
    const avgVotesPerProposalNumber = avgVotesPerProposal && !showBlur ? avgVotesPerProposal : 429;
    const totalVotes = FormatUtils.formatExistingNumber(votesNumber, 0);
    const totalVoters = FormatUtils.formatExistingNumber(totalVotesNumber, 0);
    const votesPerProposal = !FormatUtils.checkIfDataNotExist(avgVotesPerProposalNumber)
        ? FormatUtils.formatNumberWithCommas(FormatUtils.convertToBigIntNumber(avgVotesPerProposalNumber as number), 0)
        : DATA_NOT_FOUND;

    return (
        <div className={styles.mainWrapper}>
            <TableHeader>
                <div className={styles.totalVotes}>Total Votes</div>
                <div className={styles.voters}>Voters</div>
                <div className={styles.avgVotes}>Avg. Votes per Proposal</div>
            </TableHeader>
            <TableRow className={showBlur ? styles.minHeight : ''}>
                <div className={styles.totalVotes}>{totalVotes}</div>
                <div className={styles.voters}>{totalVoters}</div>
                <div className={styles.avgVotes}>
                    <TooltipWrapper title={votesPerProposal}>
                        <span>{votesPerProposal}</span>
                    </TooltipWrapper>
                </div>
                {showBlur && (
                    <TableProBlur
                        title="Lifetime Voter Activity is a DeepDAO Pro feature"
                        description={TRENDS_TAB_DESCRIPTIONS[TRENDS_TAB.LIFETIME_VOTER]}
                    />
                )}
            </TableRow>
        </div>
    );
};
